<template>
  <div>
    <!-- <PDCAlert></PDCAlert> -->
    <UsageAlert :token="token" :agreed="user.privacyAndTCAgree"></UsageAlert>
    <UpdateAlert></UpdateAlert>
  </div>
</template>

<script>
import UsageAlert from './UsageAlert.vue'
import UpdateAlert from './UpdateAlert.vue'
// import PDCAlert from './PDCAlert.vue'

export default {
  components: {
    UsageAlert,
    // PDCAlert,
    UpdateAlert
  },
  props: ['token', 'user']
}
</script>
